import { DocumentVersion } from "@models";
import { DocumentStatus } from "@types";
import { PatchDocumentVersionData } from "@types";

export const DOC_GENERATION_DEBUG_PREFIX = "[doc-generation-debug]";

type LoggableDocumentVersion = Pick<
  DocumentVersion,
  "id" | "readyForApproval" | "revision" | "snapshot" | "contentTemplate"
>;

const hasOwnPatchField = (
  data: PatchDocumentVersionData,
  key: keyof PatchDocumentVersionData
) => Object.prototype.hasOwnProperty.call(data, key);

export const getDocGenerationState = ({
  docId,
  status,
  version,
  versionId,
}: {
  docId?: string | null;
  status?: DocumentStatus | string | null;
  version?: LoggableDocumentVersion | null;
  versionId?: string | null;
}) => ({
  docId: docId ?? null,
  versionId: version?.id ?? versionId ?? null,
  status: status ?? null,
  readyForApproval: version?.readyForApproval ?? null,
  revision: version?.revision ?? null,
  hasSnapshot: version ? version.snapshot != null : null,
  hasContentTemplate: version ? version.contentTemplate != null : null,
});

export const getDocGenerationPatchFields = (
  data: PatchDocumentVersionData
) => ({
  updatesReadyForApproval: hasOwnPatchField(data, "readyForApproval"),
  updatesContentTemplate: hasOwnPatchField(data, "contentTemplate"),
  requestedReadyForApproval: hasOwnPatchField(data, "readyForApproval")
    ? (data.readyForApproval ?? null)
    : null,
});

export const isDocGenerationRelevantPatch = (
  data: PatchDocumentVersionData
) => {
  const patchFields = getDocGenerationPatchFields(data);
  return (
    patchFields.updatesReadyForApproval || patchFields.updatesContentTemplate
  );
};

export const logDocGenerationInfo = (
  event: string,
  payload: Record<string, unknown>
) => {
  void event;
  void payload;
};

export const logDocGenerationWarn = (
  event: string,
  payload: Record<string, unknown>
) => {
  void event;
  void payload;
};
